var AbstractResourcesView = require("../common/AbstractResourcesView");
var Utils = require("common/Utils");

/**
 * @abstract
 * @class
 * @extends {AbstractResourcesView}
 * @constructor
 */
function AbstractFavouritesEditView() {
    AbstractResourcesView.call(this);
    var self = this;

    // Create the cancel button and bind it to a back request to the NavigationManager
    var $cancelButton = $('<a href="#" data-role="button" data-icon="mobile-close" data-iconpos="notext" data-inline="true">');
    $cancelButton.on("click", function() {
        self.publishEvent("NavigationManager", "go-back");
    });

    this.getContent().css({position : "fixed"});  // Prevent the div from scrolling beyond its content
    this.getContent().removeClass("pullToRefresh");  // We don't want to allow pull to refresh on edit views

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "fullscreen";
    };

    var super_headerConfig = this.getHeaderConfiguration;
    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        var headerConfig = super_headerConfig();
        headerConfig.searchHeader.hide();
        headerConfig.searchHeader = undefined; // Don't allow searching
        return $.extend(headerConfig, {
            leftButtons : [$cancelButton]
        });
    };
}

Utils.inherits(AbstractFavouritesEditView, AbstractResourcesView);

module.exports = AbstractFavouritesEditView;


//////////////////
// WEBPACK FOOTER
// ./favourites/AbstractFavouritesEditView.js
// module id = 74
// module chunks = 0